import { render, staticRenderFns } from "./ListOrders.vue?vue&type=template&id=35ccf82e&scoped=true"
import script from "./ListOrders.vue?vue&type=script&lang=js"
export * from "./ListOrders.vue?vue&type=script&lang=js"
import style0 from "./ListOrders.vue?vue&type=style&index=0&id=35ccf82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ccf82e",
  null
  
)

export default component.exports